import debounce from 'lodash/debounce';
import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[heightOverflow]',
  exportAs: 'heightOverflow',
})
export class HeightOverflowDirective implements AfterViewInit {
  @Input('heightOverflow') public heightOverflow: string = 'height-overflow';
  private el: HTMLElement;
  private debouncedOverflowCheck = debounce(this.overflowCheck, 100);

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  public ngAfterViewInit() {
    this.overflowCheck();
  }

  public overflowCheck(): void {
    const el: HTMLElement = this.el;
    const scrollHeight: number = el.scrollHeight;
    const offsetHeight: number = el.offsetHeight;
    const isClassAdded: boolean = el.classList.contains(this.heightOverflow);

    if (scrollHeight > offsetHeight && !isClassAdded) {
      el.classList.add(this.heightOverflow);
    } else if (scrollHeight <= offsetHeight && isClassAdded) {
      el.classList.remove(this.heightOverflow);
    }
  }

  @HostListener('window:resize')
  private onResize() {
    this.debouncedOverflowCheck();
  }
}
